import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';

export const CommunicationHub = () => (
    <ModalWrapper>
        <ModalHeader title={lt('MessagePlural')} />
        <NewModalBodyWrapper padded>
            <>test </>
        </NewModalBodyWrapper>
    </ModalWrapper>
);
